// extracted by mini-css-extract-plugin
export default {"logo":"header_logo__laEkK","expand":"header_expand__2rf62","collapse":"header_collapse__ImufQ","desktop":"header_desktop__gtHax","mobile":"header_mobile__XrhZh"};